module.exports = __webpack_public_path__ + "static/media/javascript-logo.2118ade8.png";